import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ContactsList from './contactsList';
// import SelectContent from './AuthUI/SelectContent';


import MenuContent from './AuthUI/MenuContent';
import CardAlert from './AuthUI/CardAlert';
import OptionsMenu from './AuthUI/OptionsMenu';


import MenuIcon from '@mui/icons-material/Menu'




const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: 0,
  [theme.breakpoints.up('sm')]: {
    width: 0,
  },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, visible }) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(28, 28, 28, 0.38)',
    opacity: visible,
    transition: theme.transitions.create([ 'width', 'opacity' ], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
      {
        props: ({ open }) => open,
        style: {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
          backgroundColor: 'rgba(28, 28, 28, 0.38)',
        },
      },
      {
        props: ({ open }) => !open,
        style: {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
          backgroundColor: 'rgba(28, 28, 28, 0.38)',
        },
      },
    ],
  }),
);




export default function CustomDrawer( { open, setOpen, isSmall, position='relative',left=0, top=0, side='right' }) {

    
    // const [open, setOpen] = React.useState(false);

  return (
    <Drawer
      variant="permanent"
      anchor={side}
      open={open}
      // visible={true}


      sx={{
        // display: { xs: 'none', md: 'block' },
        height: '100%',
        [`& .${drawerClasses.paper}`]: {
            overflow: 'auto',
          backgroundImage: 'none',
          position: {position},
          backgroundColor: 'rgba(28, 28, 28, 0.38)',
          // backdropFilter: 'blur(1px)',
          height: '100%'
        },
      }}
    >
        
      
        {/* {currentUser && <LogoutMenuItem open={open} close={handleDrawerClose} />} */}
        {/* {!currentUser && <Login short={!open} />} */}
        
      {/* <Box
        sx={{
          display: 'flex',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
        }}
      >
        <SelectContent />
      </Box> */}
      <Divider />
      <ContactsList />      
    </Drawer>
  );
}
